// navItems.js

import HomeIcon from "@mui/icons-material/Home";
import FolderIcon from "@mui/icons-material/Folder";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import SearchIcon from "@mui/icons-material/Search";

export const navItems = [
  {
    label: "Home",
    path: "/app",
    exact: true,
    icon: <HomeIcon />,
  },
  {
    label: "New FPZ Report",
    path: "/app/new",
    icon: <AddCircleOutlineIcon />,
    secondary: "Create",
  },
  {
    label: "Saved FPZ Reports",
    path: "/app/account/reports",
    icon: <FolderIcon />,
    secondary: "Library",
  },
  {
    label: "Search Companies",
    path: "/app/companies",
    icon: <SearchIcon />,
  },
];
